// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Q6XK","selected":"Chip_selected__cyOiO"};